import { render, staticRenderFns } from "./filePreviewForPC.vue?vue&type=template&id=02631164&scoped=true"
import script from "./filePreviewForPC.vue?vue&type=script&lang=js"
export * from "./filePreviewForPC.vue?vue&type=script&lang=js"
import style0 from "./filePreviewForPC.vue?vue&type=style&index=0&id=02631164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02631164",
  null
  
)

export default component.exports